import {
  Directive, ElementRef,
  inject,
} from "@angular/core";
import {
  IWidgetConfig, provideAsWidgetRef
} from '@wm/components-base';
import { addClass } from '@wm/core';

const DEFAULT_CLS = 'app-page container';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-page',
  hostClass: DEFAULT_CLS
}

@Directive({
  selector: '[wmPage]',
  providers: [
    provideAsWidgetRef(MobilePageDirective)
  ],
  standalone: true,
  exportAs: 'wmPage'
})
export class MobilePageDirective {
  private el: JQuery<HTMLElement>;
 constructor() {
   let elementRef = inject(ElementRef);
   this.el = $(elementRef.nativeElement);
   addClass(elementRef.nativeElement, 'mobile-app-page');
 }

}
